import React, { useState, useEffect } from "react";
import SideNav from "./SideNav";
import StateFarmCheckModal from "./StateFarmCheckModal";
import LargeCard from "./LargeCard";
import {
  useAllUsers,
  useUnapprovedTestimonials,
  deleteTestimonial,
  updateTestimonial,
  useAllTeams,
  updateUserDnd,
  grantUserProductAccess,
  revokeUserProductAccess,
} from "../../util/db";
import CSVExporter from "./CSVExporter";
import { Menu } from '@headlessui/react'
import { UserCircleIcon, ChevronDownIcon } from "@heroicons/react/24/solid";
import LoadingIcon from "../LoadingIcon";
import { getStripePriceId } from "../../util/prices";
import PasswordUpdateButton from "./PasswordUpdateButton";
import EmailUpdateButton from "./EmailUpdateButton";
import TeamEditModal from "./TeamEditModal";
import { getPlanName } from "../../util/prices";

const columns = ["Tools", "Name", "Email", "Phone Number", "Company", "Team", "Subscription(s)"]
const allArray = [
  getStripePriceId("sbm"),
  getStripePriceId("sby"),
  getStripePriceId("sbm1"),
  getStripePriceId("tp"),
  getStripePriceId("tpm"),
  getStripePriceId("tpl"),
  getStripePriceId("proc"),
  getStripePriceId("procm"),
  getStripePriceId("life"),
]
const legacyAllArray = ["life", "tp", "proc", "sby", "sbm"]
const grantableProducts = [
  { id: "life", label: "All Access Membership" },
  { id: "tp", label: getPlanName("tp") || "Agency Training (Yearly)" },
  { id: "tpm", label: getPlanName("tpm") || "Agency Training (Monthly)" },
  { id: "tpl", label: getPlanName("tp") || "Agency Training (Lifetime)" },
  { id: "proc", label: getPlanName("proc") || "Tool Kit (Yearly)" },
  { id: "procm", label: getPlanName("procm") || "Tool Kit (Monthly)" },
  { id: "sby", label: getPlanName("sby") || "Stairs & Buckets (Yearly)" },
  { id: "sbm", label: getPlanName("sby") || "Stairs & Buckets (Monthly)" },
  { id: "sbm1", label: getPlanName("sby") || "Stairs & Buckets (Monthly)" },
];

function CRMSection(props) {
  function returnTeamModal(uid, teamsx, teamsStatusx, memberPairs) {
    if (teamsStatusx === "success" && teamsx) {
      const teamsArray = teamsx.filter((each) => each.owner === uid)

      return <>{teamsArray.map((each, k) => <TeamEditModal key={k} team =  {each} memberPairs={memberPairs}/>)}</>
      
    } else {
      return <></>
    }
  }
  function toggleElementsInList(list, elements) {
    let result = [...list]; // Work with a copy of the original list
  
    for (const element of elements) {
      const index = result.indexOf(element);
      if (index === -1) {
        // Element not found, add it
        result = [...result, element];
      } else {
        // Element found, remove it
        result = [...result.slice(0, index), ...result.slice(index + 1)];
      }
    }
  
    return result;
  }
  function haveCommonElement(arr1, arr2) {
    // Convert the first array into a set for O(1) lookups
    const set1 = new Set(arr1);
  
    // Check each element in arr2 against the set
    for (const element of arr2) {
      if (set1.has(element)) {
        return true;
      }
    }
  
    return false;
  }

  function completeFilter(people, plans, legacyPlans) {
    // Both arrays have values
    if (plans.length > 0 && legacyPlans.length > 0) {
      // Neither array contains "extraneous"
      if (!plans.includes("extraneous") && !legacyPlans.includes("extraneous")) {
        return people.filter(
          (each) =>
            (each.stripePriceIds && haveCommonElement(each.stripePriceIds, plans)) ||
            (each.legacyPlans && haveCommonElement(each.legacyPlans, legacyPlans))
        );
      } else {
        // At least one array contains "extraneous"
        const allArray = [...plans, ...legacyPlans];
        return people.filter(
          (each) =>
            (
              each.stripePriceIds &&
              each.stripePriceIds.length > 0 &&
              !haveCommonElement(each.stripePriceIds, allArray)
            ) ||
            (
              each.legacyPlans &&
              each.legacyPlans.length > 0 &&
              !haveCommonElement(each.legacyPlans, allArray)
            )
        );
      }
    }
    // Only plans array has values
    else if (plans.length > 0 && legacyPlans.length === 0) {
      if (!plans.includes("extraneous")) {
        // Include those who have common elements with plans
        return people.filter(
          (each) =>
            each.stripePriceIds &&
            each.stripePriceIds.length > 0 &&
            haveCommonElement(each.stripePriceIds, plans)
        );
      } else {
        // "extraneous" in plans: exclude those who have common elements with plans
        return people.filter(
          (each) =>
            each.stripePriceIds &&
            each.stripePriceIds.length > 0 &&
            !haveCommonElement(each.stripePriceIds, allArray)
        );
      }
    }
    // Only legacyPlans array has values
    else if (legacyPlans.length > 0 && plans.length === 0) {
      if (!legacyPlans.includes("extraneous")) {
        // Include those who have common elements with legacyPlans
        return people.filter(
          (each) =>
            each.legacyPlans &&
            each.legacyPlans.length > 0 &&
            haveCommonElement(each.legacyPlans, legacyPlans)
        );
      } else {
        // "extraneous" in legacyPlans: exclude those who have common elements with legacyPlans
        return people.filter(
          (each) =>
            each.legacyPlans &&
            each.legacyPlans.length > 0 &&
            !haveCommonElement(each.legacyPlans, legacyAllArray)
        );
      }
    }
    // Both arrays are empty
    else {
      // No criteria, return all people or implement desired logic
      return people;
    }
  }

  function findConflatedSubscriptions(people) {
    setPlanFilters([])
    setLegacyPlanFilters([])
      return people.filter((each) => (each.legacyPlans && each.legacyPlans?.length >0 && each.stripePriceIds && each.stripePriceIds?.length >0))
  }

  function findNonMigratedUsers(people) {
    setPlanFilters([])
    setLegacyPlanFilters([])
      return people.filter((each) => (each.importResolutionRequired === true))
  }


  // Build a lookup of member UID -> team owner(s) for displaying team relationships
  function getTeamInfo(person, allPeople) {
    const info = { isOwner: false, memberCount: 0, members: [], isTeamMember: false, owners: [] };

    // Check if this person is a team owner
    if (person.teamMembers && person.teamMembers.length > 0) {
      info.isOwner = true;
      info.memberCount = person.teamMembers.length;
      info.members = person.teamMembers.map((uid) => {
        const member = allPeople.find((p) => p.id === uid);
        return member ? (member.name || member.email) : uid;
      });
    }

    // Check if this person is on someone else's team
    if (allPeople) {
      const owners = allPeople.filter((p) =>
        p.teamMembers && p.teamMembers.includes(person.id)
      );
      if (owners.length > 0) {
        info.isTeamMember = true;
        info.owners = owners.map((o) => o.name || o.email);
      }
    }

    return info;
  }

  const [planFilters, setPlanFilters] = useState([])
  const [legacyPlanFilters, setLegacyPlanFilters] = useState([])
  const [legacyPlanOpen, setLegacyPlanOpen] = useState(false)
  const [planOpen, setPlanOpen] = useState(false)
  const [filteredPeople, setFilteredPeople] = useState(false)
  const [emailUidPairs, setEmailUidPairs] = useState({});
  const [expandedDndUserId, setExpandedDndUserId] = useState(null);
  const [dndDrafts, setDndDrafts] = useState({});
  const [savingDndUserId, setSavingDndUserId] = useState(null);
  const [dndStatusByUser, setDndStatusByUser] = useState({});
  const [grantDrafts, setGrantDrafts] = useState({});
  const [savingGrantUserId, setSavingGrantUserId] = useState(null);
  const [grantStatusByUser, setGrantStatusByUser] = useState({});

  function getDndDraft(person) {
    return {
      dndAll: Boolean(person.dndAll),
      dndEmail: Boolean(person.dndEmail),
      dndSms: Boolean(person.dndSms),
    };
  }

  function toggleDndEditor(person) {
    setExpandedDndUserId((prev) => prev === person.id ? null : person.id);
    setDndStatusByUser((prev) => ({...prev, [person.id]: null}));
    setGrantStatusByUser((prev) => ({...prev, [person.id]: null}));
    setDndDrafts((prev) => ({
      ...prev,
      [person.id]: prev[person.id] || getDndDraft(person),
    }));
    setGrantDrafts((prev) => ({
      ...prev,
      [person.id]: prev[person.id] || { productId: "", note: "" },
    }));
  }

  function updateDndDraft(uid, field, value) {
    setDndDrafts((prev) => ({
      ...prev,
      [uid]: {
        ...(prev[uid] || {}),
        [field]: value === "true",
      },
    }));
  }

  async function saveDnd(uid) {
    const draft = dndDrafts[uid];
    if (!draft) return;
    setSavingDndUserId(uid);
    setDndStatusByUser((prev) => ({...prev, [uid]: null}));
    try {
      await updateUserDnd(uid, draft, "admin_crm");
      setDndStatusByUser((prev) => ({
        ...prev,
        [uid]: {type: "success", message: "Saved. Sync to connected systems is now queued."},
      }));
    } catch (err) {
      setDndStatusByUser((prev) => ({
        ...prev,
        [uid]: {type: "error", message: err.message || "Failed to update DND settings."},
      }));
    } finally {
      setSavingDndUserId(null);
    }
  }

  function updateGrantDraft(uid, field, value) {
    setGrantDrafts((prev) => ({
      ...prev,
      [uid]: {
        ...(prev[uid] || { productId: "", note: "" }),
        [field]: value,
      },
    }));
  }

  // Grant and revoke both go through api/admin-grant-product.js, which checks
  // the caller is an admin server-side, validates the price against the
  // grantable list, records or removes the adminGrants entry, and writes the
  // audit row with the Admin SDK. The browser no longer writes any of it.
  // Nothing is created or cancelled in Stripe: a grant is a server-side
  // record (decision, Ben, 2026-09-23).
  async function changeGrantAccess(person, action) {
    const uid = person.id;
    const draft = grantDrafts[uid] || { productId: "", note: "" };
    const trimmedNote = draft.note.trim();
    const verb = action === "revoke" ? "revoke" : "grant";

    if (!draft.productId) {
      setGrantStatusByUser((prev) => ({
        ...prev,
        [uid]: { type: "error", message: `Select a product before you ${verb} it.` },
      }));
      return;
    }

    if (!trimmedNote) {
      setGrantStatusByUser((prev) => ({
        ...prev,
        [uid]: { type: "error", message: `A note is required to ${verb} access.` },
      }));
      return;
    }

    setSavingGrantUserId(uid);
    setGrantStatusByUser((prev) => ({...prev, [uid]: null}));

    try {
      const result = verb === "revoke"
        ? await revokeUserProductAccess({
          targetUserId: uid,
          productId: draft.productId,
          note: trimmedNote,
        })
        : await grantUserProductAccess({
          targetUserId: uid,
          productId: draft.productId,
          note: trimmedNote,
        });

      let message;
      if (verb === "revoke") {
        message = result?.revoked === false
          ? (result.message || "No admin grant for that product on this account.")
          : "Access revoked and logged." +
            (result?.statusChanged
              ? " No grants or live subscriptions remain, so the account is now canceled."
              : result?.liveSubscription
                ? " The account stays active: Stripe shows a live subscription."
                : result?.remainingGrants
                  ? ` The account stays active: ${result.remainingGrants} other grant(s) remain.`
                  : "");
      } else {
        message = "Access granted and logged." +
          (result?.statusChanged ? " The account was lapsed and is now active." : "");
      }

      const failed = verb === "revoke" && result?.revoked === false;
      setGrantStatusByUser((prev) => ({
        ...prev,
        [uid]: {
          type: failed ? "error" : "success",
          message,
        },
      }));
      if (!failed) {
        setGrantDrafts((prev) => ({
          ...prev,
          [uid]: { productId: "", note: "" },
        }));
      }
    } catch (err) {
      setGrantStatusByUser((prev) => ({
        ...prev,
        [uid]: {
          type: "error",
          message: err.message || `Failed to ${verb} product access.`,
        },
      }));
    } finally {
      setSavingGrantUserId(null);
    }
  }

  const extractEmailUidPairs = (data) => {
    if (!Array.isArray(data)) {
      console.error("Input must be an array of JSON objects");
      return {};
    }

    return data.reduce((acc, item) => {
      if (item.email && item.id) {
        acc[item.email] = item.id;
      }
      return acc;
    }, {});
  };

  const {
    data: testimonials,
    status: testimonialsStatus,
    error: testimonialsError
  } = useUnapprovedTestimonials()

  const {
    data: teams,
    status: teamsStatus,
    error: teamsError
  } = useAllTeams()

  const {data: people,
    status: peopleStatus,
    error: peopleError,
  } = useAllUsers()


//   const peopleStatus = "success"
//   const people = [{
//     "id": "024huWtGPmcnoGdIldWoaxOchP53",
//     "legacyInterval": "year",
//     "stripeCustomerId": "cus_Q6gX6QK6RCweaS",
//     "stripePriceIds": ["price_1Pm0tdDfbx1GFSizzdQiRiKN"],
//     "email": "trevor@insurewithtink.com",
//     "importResolutionRequired": true,
//     "legacyPlans": [
//         "sby"
//     ],
//     "legacyRecentPayment": {
//         "seconds": 1728274946,
//         "nanoseconds": 798000000
//     }
// }]

useEffect(() => {
  if (people && people.length > 0) {
    const result = extractEmailUidPairs(people);
    // Only update state if result is different from current state
    if (JSON.stringify(result) !== JSON.stringify(emailUidPairs)) {
      setEmailUidPairs(result);
    }
  }
}, [people, emailUidPairs]); // Dependency array ensures it runs when jsonArray changes


  return (
    <>
      <div className="container">
      <div className="flex w-full">

        <div className="flex-grow px-4">
          <>
          {(testimonials && testimonialsStatus === "success" && testimonials.length >0)&&
          <LargeCard titleDescriptions  ={[{title: "Testimonials Awaiting Approval", description: "Approve testimonials before they go live."}]}>
        {(testimonials && testimonialsStatus === "success" && testimonials.length>0)?testimonials.map((testimonial, index) => (
            <>
            <div className="flex flex-row items-center">
              <div className="flex flex-col">
                <button onClick={() => updateTestimonial(testimonial.id, {approved: true})} className="bg-green-700 text-white h-min m-2 p-2 rounded-lg">Approve Testimonial</button>
                <button onClick={() => deleteTestimonial(testimonial.id)} className="bg-red-700 text-white h-min m-2 p-2 rounded-lg">Delete Testimonial</button>
              </div>
            {(testimonial.type === "text")&&
            <div
              className="flex-1 border rounded-md border-green-700 relative min-w-[300px] max-w-full"
              key={index}
            >
              <div className="absolute top-0 right-0 text-8xl mt-1 mr-2 text-green-700 opacity-75 font-serif">
                “
              </div>
              <div className="px-4 pt-14 pb-6 sm:px-6 sm:pb-6 relative">
                <blockquote>
                <p className="leading-7 mb-2 font-bold">{testimonial.title}</p>
                  <p className="leading-7 mb-5">{testimonial.description}</p>
                  <footer className="flex items-center space-x-4">
                    <UserCircleIcon className="h-16" />
                    <div>
                      <span className="font-semibold text-green-700">
                        {testimonial.display_name}
                      </span>
                    </div>
                  </footer>
                </blockquote>
              </div>
            </div>
            }
            </div>

            {(testimonial.type === "video")&&<div>This would be a video</div>}
            </>
          )):
          <div className="flex w-full justify-center items-center">
          {(testimonialsStatus !== "success")&&<LoadingIcon className="h-12"/>}
          </div>
          }
        </LargeCard>}
        <div className="flex w-full pt-2">
        <LargeCard titleDescriptions = {[{title: "Customers", description: "Here you can view and manage our customers..."}]}>
        {(peopleStatus === "success" && people && people.length >0)&& (
        <div className="p-1 divide-solid divide-y">
          <div className="w-full flex justify-end mb-2 space-x-2">
            {filteredPeople&&<CSVExporter data = {filteredPeople}/>}
            {filteredPeople&&<button className="border border-green-700 rounded-full px-2 text-green-700 bg-green-50"
              onClick={() => {
                setFilteredPeople(false)
                setPlanFilters([])
                setLegacyPlanFilters([])
              }}
            >Clear Filters</button>}
            <button className="border border-green-700 rounded-full px-2 text-green-700 bg-green-50"
              onClick={() => setFilteredPeople(findConflatedSubscriptions(people))}
            >Find Conflated Subscriptions</button>
            <button className="border border-green-700 rounded-full px-2 text-green-700 bg-green-50"
              onClick={() => setFilteredPeople(findNonMigratedUsers(people))}
            >Find Non-Migrated Users</button>
          <Menu as="div" className="relative inline-block text-left">
            <div>
              <Menu.Button onClick={() => setPlanOpen(!planOpen)} className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                Filter By Plan
                <ChevronDownIcon aria-hidden="true" className="-mr-1 h-6 w-6 text-gray-400" />
              </Menu.Button>
            </div>

            {planOpen&&<Menu.Items
              static
              className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5"
            >
              <div className="py-1">
                <Menu.Item>
                  <button
                    onClick={() => setPlanFilters(toggleElementsInList(planFilters, [getStripePriceId("life")]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${planFilters.includes(getStripePriceId("life"))&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Million Dollar Membership
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => setPlanFilters(toggleElementsInList(planFilters, [getStripePriceId("tp"),getStripePriceId("tpm"),getStripePriceId("tpl")]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${planFilters.includes(getStripePriceId("tp"))&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Million Dollar Road Map
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => setPlanFilters(toggleElementsInList(planFilters, [getStripePriceId("proc"),getStripePriceId("procm")]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${planFilters.includes(getStripePriceId("proc"))&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Million Dollar Toolkit
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => setPlanFilters(toggleElementsInList(planFilters, [getStripePriceId("sbm"),getStripePriceId("sby"),getStripePriceId("sbm1"),]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${planFilters.includes(getStripePriceId("sby"))&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Million Dollar Startup
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => setPlanFilters(toggleElementsInList(planFilters, ["extraneous"]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${planFilters.includes("extraneous")&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Others
                  </button>
                </Menu.Item>
                  <Menu.Item>
                    <button
                    onClick={()=>{
                      setPlanOpen(false)
                      setFilteredPeople(completeFilter(people, planFilters, legacyPlanFilters))
                    }}
                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                    >
                      Apply Filter
                    </button>
                  </Menu.Item>
              </div>
            </Menu.Items>}
          </Menu>
          <Menu as="div" className="relative inline-block text-left">
            <div>
              <Menu.Button onClick={() => setLegacyPlanOpen(!legacyPlanOpen)} className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
                Filter By Legacy Plans
                <ChevronDownIcon aria-hidden="true" className="-mr-1 h-6 w-6 text-gray-400" />
              </Menu.Button>
            </div>

            {legacyPlanOpen&&<Menu.Items
              static
              className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5"
            >
              <div className="py-1">
                <Menu.Item>
                  <button
                    onClick={() => setLegacyPlanFilters(toggleElementsInList(legacyPlanFilters, ["life"]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${legacyPlanFilters.includes("life")&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Legacy Million Dollar Membership
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => setLegacyPlanFilters(toggleElementsInList(legacyPlanFilters, ["tp"]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${legacyPlanFilters.includes("tp")&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Legacy Agency Training
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => setLegacyPlanFilters(toggleElementsInList(legacyPlanFilters, ["proc"]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${legacyPlanFilters.includes("proc")&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Legacy Sales Processes
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => setLegacyPlanFilters(toggleElementsInList(legacyPlanFilters, ["sby", "sbm"]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${legacyPlanFilters.includes("sby")&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Legacy Stairs and Buckets
                  </button>
                </Menu.Item>
                <Menu.Item>
                  <button
                    onClick={() => setLegacyPlanFilters(toggleElementsInList(legacyPlanFilters, ["extraneous"]))}
                    className={`block px-4 py-2 text-sm text-gray-700 mx-2 ${legacyPlanFilters.includes("extraneous")&&"border rounded-md bg-green-100 border-green-700 text-green-700"}`}
                  >
                    Others
                  </button>
                </Menu.Item>
                  <Menu.Item>
                    <button
                    onClick={()=>{
                      setLegacyPlanOpen(false)
                      setFilteredPeople(legacyPlanFilters.length>0?completeFilter(people, planFilters, legacyPlanFilters):false)
                    }}
                      className="block w-full px-4 py-2 text-left text-sm text-gray-700"
                    >
                      Apply Filter
                    </button>
                  </Menu.Item>
              </div>
            </Menu.Items>}
          </Menu>
          </div>
        <div className="flex justify-between py-2 px-2 font-bold">
        {columns.map((each, k) => 
        <div key = {each} className={`w-1/7 ${k===0?"text-start":"text-center"}`}>{each}</div>
        )}
        </div>

        {(filteredPeople?filteredPeople:people).map((person, k) => (
          <React.Fragment key={person.id}>
            <div className={`flex justify-between py-2 px-2 text-sm text-gray-500 ${k %2===0?"bg-green-50":""}`}>
              <div className="text-start flex flex-col">
                <PasswordUpdateButton uid = {person.id}/>
                <EmailUpdateButton uid = {person.id}/>
                {returnTeamModal(person.id, teams, teamsStatus, emailUidPairs)}
                {/* {(teams && teamsStatus.length > 0)&&<TeamEditModal team={ memberPairs = {emailUidPairs}/>} */}
              </div>
              <div className="w-1/6 text-center">
                <button
                  type="button"
                  onClick={() => toggleDndEditor(person)}
                  className="text-green-700 hover:text-green-900 underline decoration-dotted"
                >
                  {person.name ? person.name : "Not Provided"}
                </button>
              </div>
              <div className="w-1/6 text-center">{person.email?person.email: "Not Provided"}</div>
              <div className="w-1/6 text-center">{person.phone?person.phone: "Not Provided"}</div>
              <div className="w-1/6 text-center">{person.company?person.company: "Not Provided"}</div>
              <div className="w-1/6 text-center text-xs">
                {(() => {
                  const teamInfo = getTeamInfo(person, people);
                  return (
                    <>
                      {teamInfo.isOwner && (
                        <div className="text-green-700 font-semibold" title={teamInfo.members.join(", ")}>
                          Owner ({teamInfo.memberCount} members)
                        </div>
                      )}
                      {teamInfo.isTeamMember && (
                        <div className="text-blue-600">
                          Member of {teamInfo.owners.join(", ")}
                        </div>
                      )}
                      {!teamInfo.isOwner && !teamInfo.isTeamMember && (
                        <span className="text-gray-300">-</span>
                      )}
                    </>
                  );
                })()}
              </div>
              <div className="w-1/6 text-center">
                {person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_LIFE) ? "All Access Membership" : ""}
                {person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_TP) || person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_TPL) ? getPlanName("tp") : ""}
                {person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_TPM) ? getPlanName("tpm") : ""}
                {person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_PROCM) ? getPlanName("procm") : ""}
                {person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_PROC) ? getPlanName("proc") : ""}
                {(person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_SBM) || person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_SBY) || person.stripePriceIds?.includes(process.env.REACT_APP_STRIPE_PRICE_SBM1)) ? getPlanName("sby") : ""} {/* TODO: Update this to use sbm and sbm1 strings from prices.js */}
                {person.stripePriceIds || person.legacyPlans ? "" : "No Subscription"}
                {person.legacyPlans?.includes("life") ? "All Access Membership Legacy" : ""}
                {person.legacyPlans?.includes("tp") ? "Trainings Package Legacy" : ""}
                {person.legacyPlans?.includes("proc") ? "Processes Package Legacy" : ""}
                {(person.legacyPlans?.includes("sbm") || person.legacyPlans?.includes('sby')) ? "Stairs and Buckets Legacy" : ""}
              </div>
            </div>

            {expandedDndUserId === person.id && (
              <div className="px-3 py-3 border-y bg-white">
                <div className="flex flex-wrap items-end gap-3">
                  <div>
                    <label className="text-xs text-gray-500 block mb-1">All Channels</label>
                    <select
                      value={String((dndDrafts[person.id] || getDndDraft(person)).dndAll)}
                      onChange={(e) => updateDndDraft(person.id, "dndAll", e.target.value)}
                      className="border rounded px-2 py-1 text-sm"
                      disabled={savingDndUserId === person.id}
                    >
                      <option value="false">Off</option>
                      <option value="true">On</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500 block mb-1">Email</label>
                    <select
                      value={String((dndDrafts[person.id] || getDndDraft(person)).dndEmail)}
                      onChange={(e) => updateDndDraft(person.id, "dndEmail", e.target.value)}
                      className="border rounded px-2 py-1 text-sm"
                      disabled={savingDndUserId === person.id}
                    >
                      <option value="false">Off</option>
                      <option value="true">On</option>
                    </select>
                  </div>
                  <div>
                    <label className="text-xs text-gray-500 block mb-1">SMS</label>
                    <select
                      value={String((dndDrafts[person.id] || getDndDraft(person)).dndSms)}
                      onChange={(e) => updateDndDraft(person.id, "dndSms", e.target.value)}
                      className="border rounded px-2 py-1 text-sm"
                      disabled={savingDndUserId === person.id}
                    >
                      <option value="false">Off</option>
                      <option value="true">On</option>
                    </select>
                  </div>
                  <button
                    type="button"
                    onClick={() => saveDnd(person.id)}
                    disabled={savingDndUserId === person.id}
                    className="px-3 py-1.5 bg-green-700 text-white rounded text-sm hover:bg-green-800 disabled:opacity-50"
                  >
                    {savingDndUserId === person.id ? "Saving..." : "Save DND"}
                  </button>
                  <button
                    type="button"
                    onClick={() => setExpandedDndUserId(null)}
                    disabled={savingDndUserId === person.id}
                    className="px-3 py-1.5 border border-gray-300 rounded text-sm text-gray-600 hover:bg-gray-50"
                  >
                    Close
                  </button>
                </div>
                <p className="mt-2 text-xs text-gray-500">
                  Last source: {person.dndSource || "unknown"} | Last updated: {person.dndUpdatedAt?.toDate ? person.dndUpdatedAt.toDate().toLocaleString() : "n/a"}
                </p>
                {dndStatusByUser[person.id] && (
                  <p className={`mt-2 text-sm ${dndStatusByUser[person.id].type === "error" ? "text-red-600" : "text-green-700"}`}>
                    {dndStatusByUser[person.id].message}
                  </p>
                )}
                <div className="mt-4 border-t pt-4">
                  <p className="text-sm font-semibold text-gray-700">Product Access</p>
                  <p className="text-xs text-gray-500">
                    A grant is recorded on the account, not in Stripe: no subscription is
                    created and nothing is billed. It survives the user's next purchase and
                    can be taken back. A lapsed account is activated so the grant actually
                    works; an already-active one is left alone. Revoking only cancels the
                    account if no other grant and no live Stripe subscription remain. The
                    note, the admin and the time are logged.
                  </p>
                  <div className="mt-2 flex flex-col gap-2 max-w-xl">
                    <div>
                      <label className="text-xs text-gray-500 block mb-1">Product</label>
                      <select
                        value={(grantDrafts[person.id] || { productId: "", note: "" }).productId}
                        onChange={(e) => updateGrantDraft(person.id, "productId", e.target.value)}
                        className="border rounded px-2 py-1 text-sm w-full"
                        disabled={savingGrantUserId === person.id}
                      >
                        <option value="">Select a product...</option>
                        {grantableProducts.map((product) => (
                          <option key={product.id} value={product.id}>{product.label}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="text-xs text-gray-500 block mb-1">Required note (reason)</label>
                      <textarea
                        value={(grantDrafts[person.id] || { productId: "", note: "" }).note}
                        onChange={(e) => updateGrantDraft(person.id, "note", e.target.value)}
                        className="border rounded px-2 py-1 text-sm w-full min-h-[84px]"
                        placeholder="Explain why access is being granted..."
                        disabled={savingGrantUserId === person.id}
                        required
                      />
                    </div>
                    <div className="flex gap-2">
                      <button
                        type="button"
                        onClick={() => changeGrantAccess(person, "grant")}
                        disabled={savingGrantUserId === person.id}
                        className="px-3 py-1.5 bg-blue-700 text-white rounded text-sm hover:bg-blue-800 disabled:opacity-50"
                      >
                        {savingGrantUserId === person.id ? "Working..." : "Grant Access"}
                      </button>
                      <button
                        type="button"
                        onClick={() => changeGrantAccess(person, "revoke")}
                        disabled={savingGrantUserId === person.id}
                        className="px-3 py-1.5 border border-red-600 text-red-700 rounded text-sm hover:bg-red-50 disabled:opacity-50"
                      >
                        {savingGrantUserId === person.id ? "Working..." : "Revoke Access"}
                      </button>
                    </div>
                    {grantStatusByUser[person.id] && (
                      <p className={`text-sm ${
                        grantStatusByUser[person.id].type === "error" ? "text-red-600"
                          : grantStatusByUser[person.id].type === "warning" ? "text-amber-700"
                            : "text-green-700"
                      }`}>
                        {grantStatusByUser[person.id].message}
                      </p>
                    )}
                    {Array.isArray(person.adminGrants) && person.adminGrants.length > 0 && (
                      <div className="text-xs text-gray-500">
                        <p className="font-semibold">Current admin grants</p>
                        <ul className="list-disc ml-4">
                          {person.adminGrants.map((grant, i) => (
                            <li key={i}>
                              {getPlanName(grant.productId) || grant.productId || grant.priceId}
                              {grant.note ? ` — ${grant.note}` : ""}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        ))}
        </div>
        )}
            </LargeCard>
        </div>

        </>
        </div>
    </div>

      </div>
      <SideNav current = "admin"></SideNav>
      <StateFarmCheckModal onDone={() => null}/>

    </>

  );
}

export default CRMSection;
